import { render, staticRenderFns } from "./AssetDetail.vue?vue&type=template&id=6f7f8f6a&scoped=true"
import script from "./AssetDetail.vue?vue&type=script&lang=js"
export * from "./AssetDetail.vue?vue&type=script&lang=js"
import style0 from "./AssetDetail.vue?vue&type=style&index=0&id=6f7f8f6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7f8f6a",
  null
  
)

export default component.exports